import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

let Bar

const ProductAnalyticsOpportunityChart = ({ data, labels }) => {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Bar = module.Bar
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      labels,
      datasets: [
        {
          label: 'Best value for effort',
          data,
          backgroundColor: 'rgba(166, 82, 100, 0.7)',
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ display: false }],
      },
      legend: {
        onClick: (e) => e.stopPropagation(),
      },
      tooltips: {
        enabled: false,
      },
    },
  }

  return (
    <div className="chart-container">
      <div className="chart-container__description">
        <h3>Best value for effort</h3>
        <p>
          The chart combines Liquidity (chance to sell) and average transaction price (how much
          customers are paying). It indicates which categories for model creation can pay off the most.
        </p>
      </div>

      <div className="chart-container__chart">
        <Bar redraw data={chartConfiguration.data} options={chartConfiguration.options} />
      </div>
    </div>
  )
}

ProductAnalyticsOpportunityChart.propTypes = {
  data: PropTypes.array,
  labels: PropTypes.array,
}

ProductAnalyticsOpportunityChart.defaultPropTypes = {
  data: [],
  labels: [],
}

export default ProductAnalyticsOpportunityChart
